import { Text } from '@heathmont/moon-core';
import Translate from '~/client/shared/i18n/Translate';
import useTermsUrl from '~/client/shared/TermsAndConditions/useTermsUrl';

const TermsLink: FC = () => {
  const termsUrl = useTermsUrl();
  return (
    <a
      href={termsUrl}
      className="inline cursor-pointer bg-transparent p-0 font-[inherit] text-piccolo no-underline"
      target="_blank"
      rel="noopener noreferrer"
    >
      <Text size={14} color="piccolo.100">
        <Translate id="profile.terms_and_conditions" />
      </Text>
    </a>
  );
};

export default TermsLink;
